import { useLoginInfo, LoginForm, useLoginReducer, TwoFactorLogin } from '@/features/login';
import { Empty } from '@/shared/components';
import { reactive } from '@/core/reactive/reactive';

export const Login = reactive.component(
  () => {
    const [form, dispatch] = useLoginReducer();
    const info = useLoginInfo();

    return (
      <Empty when={!info.isReady}>
        {form.twofactor ? (
          <TwoFactorLogin form={form} dispatch={dispatch} />
        ) : (
          <LoginForm form={form} dispatch={dispatch} />
        )}
      </Empty>
    );
  },
  {
    name: 'Login',
    monitors: services => [services.login.login],
  },
);
